import api from "./api";

const Reservations = "/reservations/reservations";
const ReservationsByStatus = "/reservations/reservationsbystatus";
const ReservationCode = "/reservations/getreservationcode";
const Add = "/reservations/add";
const Edit = "/reservations/edit";
const Del = "/reservations/delete=";
const getreservations = () => api.get(Reservations);
const getreservationCode = () => api.get(ReservationCode);
const getreservationsByStatus = () => api.get(ReservationsByStatus);

const edit = (model) => api.post(Edit, model);
const add = (model) => api.post(Add, model);
const del = (id) => api.delete(Del + id);

export default {
  getreservations,
  getreservationCode,
  getreservationsByStatus,
  edit,
  add,
  del,
};
